import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';
import RADApplication from '@/Management/RADApplication';
import DropDownListViewModel from '@/ViewModels/Controls/DropDownListViewModel';
import NumericTextBoxViewModel from '@/ViewModels/Controls/NumericTextBoxViewModel';

export default class CurrencyTextBoxViewModel extends ControlViewModel {
    private DropDownListViewModel = ComponentManager.getViewModel<typeof DropDownListViewModel>('DropDownListViewModel');

    /**
     * Das ViewModel für die NumericTextBox
     */
    public numericTextBox: NumericTextBoxViewModel

    /**
     * Das ViewModel für die DropDownList
     */
    public dropDownList: DropDownListViewModel;

    /**
     * Angabe der CurrencyExchangeGroup
     */
    public currencyExchangeGroup: string;

    /**
     * Beinhaltet die zuletzt ausgewählte Währung
     */
    private currentCurrencyId: number;

    /**
     * Der aktuelle Wert in Euro
     */
    public valueInEuro: KnockoutComputed<number>;

    /**
     * Das ViewModel für die CurrencyTextBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.numericTextBox = this.paramOrDefault(params.numericTextBox, null);
        this.dropDownList = this.paramOrDefault(params.dropDownList, null);
        this.currencyExchangeGroup = this.paramOrDefault(params.currencyExchangeGroup, '-empty-');
        this.currentCurrencyId = this.initCurrentCurrencyId();
        this.valueInEuro = this.defineComputed(() => {
            let value = +this.numericTextBox.value();
            let currencyId = this.dropDownList.value();
            let exchange = value;

            if (currencyId != null && currencyId !== 978 && currencyId !== 0) {
                exchange = this.calculateExchangeValue(value, currencyId, 978);
            }

            return exchange;
        });

        /**
         * Automatische Umrechnung des Werts in ausgewählte Währung
         */
        this.defineComputed(() => {
            let value = +this.numericTextBox.value();
            let currencyId = this.dropDownList.value();

            if (value != null && currencyId != null && this.currentCurrencyId != null && currencyId != this.currentCurrencyId) {
                _.each(RADApplication.getInstance().configuration.currencies, (currency: any) => {
                    let exchange = value;

                    if (currency.isO4217NumberCode == currencyId) {
                        exchange = this.calculateExchangeValue(exchange, this.currentCurrencyId, currencyId);
                        // nachkommastellen anpassen
                        this.numericTextBox.floatingPrecision(currency.scale);
                    }

                    if (exchange != value) {
                        this.numericTextBox.value(exchange.toString());
                    }
                });
            } else if (currencyId != null) {
                _.each(RADApplication.getInstance().configuration.currencies, (currency: any) => {

                    if (currency.isO4217NumberCode == currencyId) {
                        // nachkommastellen anpassen
                        this.numericTextBox.floatingPrecision(currency.scale);
                    }
                });
            }

            this.currentCurrencyId = currencyId;
        });
    }

    public resetValue(): void {
        this.numericTextBox.value(null);
    }

    private initCurrentCurrencyId(): number {
        let value = this.dropDownList.value();

        if (value == null || value <= 1) {
            value = RADApplication.getInstance().configuration.defaultCurrencyID;
            this.dropDownList.value(value);
        }

        return value;
    }

    /**
     * Rechnet den Wert einer Währung in eine andere um
     */
    private calculateExchangeValue(value: number, fromCurrencyId: any, toCurrencyId: number): any {
        let exchangePaths = RADApplication.getInstance().configuration.currencyExchangePaths[this.currencyExchangeGroup];

        if (exchangePaths[fromCurrencyId] != null && exchangePaths[fromCurrencyId][toCurrencyId] != null) {
            let exchangePath = exchangePaths[fromCurrencyId][toCurrencyId];
            let exchangeValue = value;

            if (exchangePath != null) {
                exchangeValue *= exchangePath.Value;
            }

            return exchangeValue;
            // wieso wurde hier gerundet? das erledigt das Control später selber anhand der floatingprecision
            //var rounded = Math.round(exchangeValue * 1000) / 1000;
            //return rounded;
        } else {
            return value;
        }
    }
}

ComponentManager.setViewModel('CurrencyTextBoxViewModel', CurrencyTextBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');